import { useServiceContext } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation } from "@tanstack/react-query";

interface CheckConsentParams {
    didomiUserProfile: any;
    didomiShouldCollect: boolean;
}

const useCheckConsent = () => {
    const consentManager = useServiceContext().sdk?.consentManager;

    const checkConsent = useMutation<boolean, Error, CheckConsentParams>({
        mutationKey: ["checkConsent"],
        mutationFn: async ({
            didomiUserProfile,
            didomiShouldCollect,
        }: CheckConsentParams): Promise<boolean> => {
            try {
                if (!consentManager) {
                    throw new Error("ConsentManager is not initialized");
                }

                const hasAllRequiredConsents =
                    await consentManager.hasAllRequiredConsents(
                        didomiUserProfile,
                        didomiShouldCollect,
                    );

                return hasAllRequiredConsents;
            } catch (error) {
                console.error("Error syncing consent:", error);
                throw error;
            }
        },
    });

    return checkConsent;
};

export default useCheckConsent;
